import React, { Component } from 'react';
import './ProgressButton.css';

class ProgressButton extends Component {
  render() {
    const { disabled, type, buttonStyle, label, loading, loadingLabel, formSubmit } = this.props;
    let buttonLabel = label;

    let classNames = ['ProgressButton'];
    if (buttonStyle) {
      classNames.push(`ProgressButton--${buttonStyle}`)
    }

    if (formSubmit) {
      classNames.push('form-submit');
    }

    if (loading) {
      classNames.push('ProgressButton--loading');
    }

    if (loading && loadingLabel) {
      buttonLabel = loadingLabel;
    }

    return (
      <button className={classNames.join(' ')} disabled={disabled} type={type}>
        {buttonLabel}
      </button>
    );
  }
}

export default ProgressButton;



// WEBPACK FOOTER //
// ./src/components/ProgressButton.js